<template>
  <div class="row">
    <div class="col-xl-12">
      <container-headline
        class="col-xl-12"
        :headline="$t('global.appointments') + ' (' + count + ')'"
        :col="3"
      >
        <div class="row mt-2 d-flex justify-content-between">
          <div class="ml-4">
            <button
              class="btn btn-success"
              @click="showNeueTerminvorlage"
              v-if="berechtigungen.m_ressourcen.create"
            >
              <font-awesome-icon icon="fa-regular fa-plus"/>
              {{ $t("global.new") }}
            </button>

            <massenmutation-button
              class="mr-2"
              style="display: inline-flex"
              :selectedIds="selectedIds"
              :propEntities="propEntities"
              :modalId="'massenmutationsmodal-terminreiter'"
              @mutated="getTermine()"
            />
          </div>
          <div class="mr-4">
            <button
              class="btn btn-danger"
              @click="oeffneLoeschenModal"
              v-if="berechtigungen.m_ressourcen.delete"
            >
              <font-awesome-icon class="mr-2" icon="fa-duotone fa-trash"/>
              <span>{{ $t("global.delete") }}</span>
            </button>
          </div>
        </div>
      </container-headline>
      <div class="row col-xl-12">
        <div class="col-xl-12 block belegliste br-t-l-0">
          <div ref="tableParent">
            <b-table
              ref="selectableTable"
              tbody-tr-class="item"
              :style="hasMaxHeight ? 'max-height: 300px' : ''"
              responsive
              sticky-header
              :items="termine"
              :fields="fieldsEducation"
              :busy="isBusy"
              show-empty
              sort-icon-left
              selectable
              select-mode="range"
              thead-tr-class="pointer"
            >
              <template v-slot:head(selected)="row">
                <b-form-checkbox
                  v-model="row.selected"
                  @input="selectAllRows(row)"
                ></b-form-checkbox>
              </template>

              <template v-slot:cell(selected)="row">
                <b-form-checkbox
                  v-model="row.item.selected"
                  @input="onRowSelected(row)"
                ></b-form-checkbox>
              </template>

              <template #table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(edit)="row" class="d-flex align-items-center">
                <div
                  class="ml-5"
                  role="button"
                  @click="editTerminvorlage(row.item)"
                >
                  <font-awesome-icon icon="fa-regular fa-pencil" size="sm"/>
                </div>
              </template>
              <template #empty>
                <div v-if="ladeFehler" class="text-center text-danger my-2">
                  <strong>{{ $t("global.errorwhileloading") }}</strong>
                </div>
                <div v-if="!ladeFehler" class="text-center text-primary my-2">
                  <strong>{{ $t("global.nodataavailable") }}</strong>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>

    <neue-terminvorlage-modal
      :id="'neue-terminvorlage-modal-' + veranstaltung.id"
      :singleSelectVeranstaltungId="'single-select-veranstaltung-' + veranstaltung.id"
      :veranstaltung="veranstaltung"
      :raum="raum"
      :planungsstati="planungsstati"
      :durchfuehrungsstati="durchfuehrungsstati"
      @confirmed="getTermine"
    ></neue-terminvorlage-modal>

    <loeschen-modal
      id="terminvorlage-loeschen-modal"
      @confirmed="terminloeschen"
      :multiple="true"
    />

  </div>
</template>

<script>
import Api from "@/api/Api";

import {apiErrorToAlert} from "@/utils/Errorhandler";
import {BSpinner} from "bootstrap-vue";
import ContainerHeadline from "@/components/ContainerHeadline";
import {LADE_AUSWAHLWERTE_DOZENT} from "@/store/dozent/actions.type";
import LoeschenModal from "@/components/Modals/LoeschenModal";
import MassenmutationButton from "@/components/Buttons/MassenmutationButton";
import reiter from "@/mixins/Reiter";
import NeueTerminvorlageModal from "@/components/Modals/NeueTerminvorlageModal.vue";
import AppApi from "@/api/AppApi";

export default {
  components: {
    NeueTerminvorlageModal,
    ContainerHeadline,
    LoeschenModal,
    BSpinner,
    MassenmutationButton,
  },
  mixins: [reiter],
  props: {
    veranstaltung: {
      type: Object,
      required: false,
    },
    raum: {
      type: String,
      required: false,
    },
    arbeitsplatz: {
      type: String,
      required: false,
    },
    shown: {
      type: Boolean,
      required: false,
    },
    terminlisteKey: {
      type: Number,
    },
  },
  data() {
    return {
      page: 0,
      count: 0,
      infiniteId: +new Date(),
      anzahlProPage: 100,
      loading: false,
      isBusy: false,
      ladeFehler: false,
      termine: [],
      langtextLoopCount: null,
      selected: [],
      selectedIds: [],
      NeueTerminvorlageModalId: "neue-terminvorlage-modal",
      propEntities: [
        {
          tbl_name: "bxc_terminvorlage",
          selectedIds: [],
        },
      ],
      massmutationModalId: "massenmutationsmodal-terminreiter",
      hasMaxHeight: true,
      showListToggleButton: null,
    };
  },
  watch: {
    shown(val) {
      if (val && this.termine.length == 0) this.getTermine();
      if (
        val &&
        (this.durchfuehrungsstati.length == 0 || this.planungsstati.length == 0)
      )
        this.$store.dispatch(`dozent/${LADE_AUSWAHLWERTE_DOZENT}`);
    },

    lektionenTotal: function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.$bus.$emit("lektionenTotal", newValue);
      }
    },
    terminlisteKey: function () {
    },
    veranstaltung(newVal) {
      if (newVal !== null) {
        this.getTermine();
      }
    },
  },
  computed: {
    fieldsEducation() {
      return [
        {key: "selected", label: ""},
        {
          key: "kalenderwoche",
          sortable: true,
          label: this.$t("global.calendar_week"),
        },
        {
          key: "wochentag.bezeichnung",
          sortable: true,
          label: this.$t("global.weekday"),
        },
        {key: "von_uhrzeit", sortable: true, label: this.$t("global.dashboard_starttime")},
        {key: "bis_uhrzeit", sortable: true, label: this.$t("global.dashboard_endtime")},
        {
          key: "lektionen",
          sortable: true,
          label: this.$t("global.lessons"),
        },
        {
          key: "bezeichnung",
          sortable: true,
          label: this.$t("global.designation"),
        },
        {
          key: "gebaeude.bezeichnung",
          sortable: true,
          label: this.$t("global.building"),
        },
        {
          key: "raeumeleitsystem",
          sortable: true,
          label: this.$t("global.rooms"),
        },
        { key: "edit", sortable: false, label: this.$t("global.edit") },
      ];
    },
    queryParams: function () {
      var params = {
        page: this.page,
      };

      if (this.suche) params.suche = this.suche;

      return params;
    },
    durchfuehrungsstati: {
      get() {
        return this.$store.state.dozent.durchfuehrungsstati;
      },
    },
    planungsstati: {
      get() {
        return this.$store.state.dozent.planungsstati;
      },
    },

    lektionenTotal: function () {
      let summeLektionen = 0;
      this.termine.forEach((el) => {
        summeLektionen += el.lektionen;
      });
      return summeLektionen;
    },
  },
  mounted() {
    this.setHeadersTerminliste("global", [
      "",
      "calendar_week",
      "weekday",
      "dashboard_starttime",
      "dashboard_endtime",
      "lessons",
      "rooms",
    ]);

    if (this.shown && this.termine.length == 0) {
      this.getTermine();
      if (
        this.durchfuehrungsstati.length == 0 ||
        this.planungsstati.length == 0
      ) {
        this.$store.dispatch(`dozent/${LADE_AUSWAHLWERTE_DOZENT}`);
      }
    }
    //this.$bus.$emit("lektionenTotal", this.lektionenTotal);

    this.$bus.$on("neuerTerminGespeichert", () => {
      this.getTermine();
    });
    this.$bus.$on("open-modal", (id) => {
      if (id === this.massmutationModalId) {
        if (!this.lehrgang) return;
        Api.get("veranstaltungen/", {
          params: {lehrgang: this.lehrgang.id},
        }).then((response) => {
          this.veranstaltungSelection = response.data;
          this.veranstaltungSelection.forEach((event) => {
            this.$set(event, "selected", false);
          });
        });
      }
    });
  },
  beforeDestroy() {
    this.$bus.$off("open-massmutation-modal");
  },

  methods: {
    
    setHeadersTerminliste(prefix, headerTexts) {
      if (this.langtextLoopCount < 15) {
        setTimeout(
          function () {
            if (this.$store.state.langtexts.loaded == true) {
              let count = 0;
              headerTexts.forEach((element) => {
                count++;
              });
            } else {
              this.langtextLoopCount++;
              this.setHeadersTerminliste(prefix, headerTexts);
            }
          }.bind(this),
          500
        );
      }
    },

    raeumeGeaendert() {
      this.selectedIds = [];
      this.getTermine();
    },

    deUpdated() {
      this.selectedIds = [];
      this.$emit("updated");
    },

    getTermine() {
      if (!this.veranstaltung?.id) return;
      this.loading = true;
      this.isBusy = true;
      AppApi.get("terminvorlage/reiter/", {
        params: {
          veranstaltungId: this.veranstaltung.id,
        },
      })
        .then((response) => {
          this.termine = response.data;
          this.count = this.termine.length;
          this.ladeFehler = false;
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
          this.ladeFehler = true;
        })
        .finally(() => {
          this.isBusy = false;
          this.loading = false;
          this.$nextTick(() => {
            this.showListToggleButton = !(
              this.$refs.tableParent.clientHeight < 300
            );
          });
        });
    },
    infiniteHandler($state) {
      if (this.shown) {
        this.loading = true;
        AppApi.get("terminvorlage/", {
          params: this.queryParams,
        }).then((response) => {
          if (response.data.length === this.anzahlProPage) {
            this.page += 1;
            this.termin.push(...response.data);
            $state.loaded();
          } else {
            this.termin.push(...response.data);
            $state.complete();
          }
        });
        this.loading = false;
      }
    },

    selectAllRows(row) {
      if (row.selected) {
        this.$refs.selectableTable.items.forEach((gp) => {
          gp.selected = true;
          if (!this.selectedIds.includes(gp.id)) {
            this.selectedIds.push(gp.id);
          }
        });
      } else {
        this.$refs.selectableTable.items.forEach((gp) => {
          gp.selected = false;
        });
        this.selectedIds = [];
      }
      this.$forceUpdate();
    },

    onRowSelected(row) {
      if (row.item.selected) {
        this.selectedIds.push(row.item.id);
      } else {
        this.selectedIds = this.selectedIds.filter((id) => id != row.item.id);
      }
    },

    showNeueTerminvorlage() {
      this.$bus.$emit(
        "openNeueTerminvorlageModal:new",
        `neue-terminvorlage-modal-${this.veranstaltung?.id}`
      );
    },
    editTerminvorlage(appointment) {
      this.$bus.$emit(
        'openNeueTerminvorlagenModal:edit',
        `neue-terminvorlage-modal-${this.veranstaltung?.id}`,
        appointment
      );
    },

    oeffneLoeschenModal() {
      if (this.selectedIds.length > 0)
        this.$bus.$emit("openLoeschenModal", "terminvorlage-loeschen-modal");
    },

    terminloeschen() {
      AppApi.delete("terminvorlage/", {
        params: {ids: this.selectedIds.join(",")},
      })
        .then(() => {
          this.getTermine();
          this.selectedIds = [];
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
        });
    },

    refresh() {
      this.selectedIds = [];
      this.getTermine();
    },

    toggleHasMaxHeight() {
      this.hasMaxHeight = !this.hasMaxHeight;
    },
  },
};
</script>
